var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "1 1 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.491a8.019 8.019 0 0 1-2.592.834c.943-.662 1.648-1.705 1.984-2.933a8.25 8.25 0 0 1-2.866 1.286c-.68-.853-1.58-1.418-2.561-1.607-.981-.19-1.988.006-2.865.557-.877.55-1.574 1.427-1.984 2.49a6.156 6.156 0 0 0-.28 3.395c-1.795-.106-3.551-.654-5.154-1.608-1.603-.954-3.017-2.293-4.15-3.93a6.02 6.02 0 0 0-.61 2.664 6.04 6.04 0 0 0 .532 2.501c.35.77.857 1.426 1.475 1.91a4.007 4.007 0 0 1-2.044-.662v.068c0 1.224.36 2.41 1.02 3.357.66.947 1.579 1.597 2.6 1.84a3.893 3.893 0 0 1-2.038.09c.288 1.054.85 1.975 1.606 2.635.756.66 1.669 1.025 2.61 1.045-1.598 1.474-3.573 2.273-5.606 2.27-.36 0-.72-.025-1.077-.074C3.063 21.177 5.465 22.003 7.918 22c8.303 0 12.843-8.075 12.843-15.079 0-.227-.005-.457-.014-.685a10.222 10.222 0 0 0 2.251-2.742L23 3.491Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.29bc35e848b1b5f6150ac35b7ddcadc3.svg";
export { ForwardRef as ReactComponent };